
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-2dd1eef6\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./tableOeth.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./tableOeth.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2dd1eef6\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tableOeth.vue.html"),
  /* scopeId */
  "data-v-2dd1eef6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dsn/tableOeth/tableOeth.vue.html
// module id = dR48
// module chunks = 2